<template>
  <div v-if="!pathMixin_isMeeting" class="bookingDropdownContainer"
  >
<!--    <Moveable-->
<!--      class="moveable small-itinerary"-->
<!--      v-bind="moveable"-->
<!--      @drag="handleDrag"-->
<!--      ref="moveable"-->
<!--    >-->
    <b-dropdown
        position="is-bottom-left"
        append-to-body
        aria-role="menu"
        style="z-index: 39 !important;"
    >
      <a
          class=""
          slot="trigger"
          role="button">

        <b-button
                size="is-default"
                :icon-right="'menu-down'"
                :type="'is-primary'"
                class="bookingDropdownTriggerButton"
            >
                 <span v-if="bookTrip.currentlyBooking" class="is-flex ml-1 mr-3 navbar-item-label">
                    <span class="mr-1">Booking in Progress:</span>
                    <b-icon v-if="bookTrip.flight" icon="airplane" class="pulsatingIcon rotate45"></b-icon>
                    <b-icon v-if="bookTrip.hotel" icon="bed-outline" class="pulsatingIcon"></b-icon>
                    <b-icon v-if="bookTrip.car" icon="car-outline" class="pulsatingIcon"></b-icon>
                 </span>
        </b-button>
      </a>
      <b-dropdown-item
        aria-role="menu-item"
        :focusable="false"
        custom
        style="padding:0 !important; min-width: 360px !important;"
      >
        <SmallItineraryPiece :sol="sol"></SmallItineraryPiece>
      </b-dropdown-item>
    </b-dropdown>
<!-- </Moveable> -->
  </div>
</template>

<script>

  import Moveable from "vue-moveable";
  import bookingMixin from "../../mixins/bookingMixin";
  import SmallItineraryPiece from "./SmallItineraryPiece";

  export default {
    name: "SmallItinerarySidebar",
    props: {
      sol: Object
    },
    mixins: [bookingMixin],
    components: {
      // Moveable,
      SmallItineraryPiece,
    },
    data: function() {
      return {
        maximized: false,
        moveable: {
          draggable: true,
          throttleDrag: 0,
          resizable: false,
          throttleResize: 1,
          keepRatio: false,
          scalable: false,
          throttleScale: 0,
          rotatable: false,
          throttleRotate: 0,
          pinchable: false, // ["draggable", "resizable", "scalable", "rotatable"]
          origin: false,
        },
      };
    },
    computed: {
      nothingBooked() {
        var solution = this.$store.state.bookTravel.result;
        return (
            Object.keys(solution.flight).length +
            Object.keys(solution.car).length +
            Object.keys(solution.hotel).length ===
            0
        );
      },
    },
    methods: {
      handleDrag({ target, transform }) {
        // console.log('onDrag left, top', transform);
        target.style.transform = transform;
      },
    },
    mounted() {
      // console.log("isMoveableElement: ", this.$refs.moveable.isMoveableElement(document));
    },
  };
</script>

<style>
  .moveable {
    position: fixed !important;
    right: 20px !important;
    width: 23%;
  }
  .moveable-line {
    position: absolute;
    width: 1px;
    height: 1px;
    width: var(--zoompx);
    height: var(--zoompx);
    background: #44aaff05 !important;
    transform-origin: 0px 50%;
  }
</style>
